import { useMemo, type ReactNode } from 'react'
import type { MatterAssetFeatureConfig } from './matter-asset-feature-config'
import { MatterAssetFeatureContext } from './matter-asset-feature-context'

/**
 * Supplies the feature config + store key to the shared matter-asset "living asset" components.
 * Renders only its children (no wrapper element) so it is layout-transparent and can wrap any
 * subtree without affecting layout.
 */
export function MatterAssetFeatureProvider({ config, storeKey, children }: { config: MatterAssetFeatureConfig; storeKey: string; children: ReactNode }) {
  const value = useMemo(() => ({ config, storeKey }), [config, storeKey])
  return <MatterAssetFeatureContext.Provider value={value}>{children}</MatterAssetFeatureContext.Provider>
}
